angular.module('mercury.dialogs', [
  'mercury.dialogs.welcome',
  'mercury.dialogs.payrolldetails'
]);
